var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fill: "none",
  d: "M24.2,11c0-1.2-1-2.2-2.2-2.2c0,0-0.1,0-0.1,0c-1.2,0-2.2,1-2.3,2.2v13.4c0,0.2-0.1,0.5-0.3,0.6 c-2.1,0.9-3.4,3-3.4,5.3c0,3.3,2.7,6,6,6s6-2.7,6-6c0-2.3-1.3-4.3-3.3-5.3c-0.2-0.1-0.4-0.3-0.4-0.6V11z M26,30.3 c-0.1,2.2-1.8,3.9-4,3.8c0,0,0,0,0,0c-2.1,0.1-3.8-1.6-3.9-3.7c0,0,0-0.1,0-0.1c0-1.9,1.4-3.6,3.3-3.9V9.8c0-0.3,0.3-0.6,0.6-0.6 c0.3,0,0.6,0.3,0.6,0.6v16.6C24.5,26.7,25.9,28.3,26,30.3z"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  fill: "#505050",
  d: "M25.5,11c0-1.9-1.5-3.4-3.4-3.4c0,0-0.1,0-0.1,0c-1.9,0-3.4,1.5-3.5,3.4v13.1c-2.3,1.2-3.7,3.6-3.7,6.2 c0,3.9,3.2,7.1,7.1,7.1c0,0,0.1,0,0.1,0c4,0.1,7.2-3.1,7.3-7.1c0,0,0,0,0,0c0-2.6-1.5-5-3.8-6.2V11z M24.6,25c2,1,3.3,3,3.3,5.3 c0,3.3-2.7,6-6,6s-6-2.7-6-6c0-2.3,1.3-4.4,3.4-5.3c0.2-0.1,0.3-0.4,0.3-0.6V11c0.1-1.2,1.1-2.2,2.3-2.2c1.2-0.1,2.2,0.9,2.3,2.1 c0,0,0,0.1,0,0.1v13.4C24.3,24.7,24.4,24.9,24.6,25z"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  fill: "#FF3B30",
  d: "M22.5,9.8c0-0.3-0.3-0.6-0.6-0.6s-0.6,0.3-0.6,0.6v16.6c-1.9,0.3-3.3,2-3.3,3.9c0,2.1,1.7,3.8,3.8,3.8 c0,0,0.1,0,0.1,0c2.2,0.1,3.9-1.6,4-3.8c0,0,0,0,0,0c0-2-1.5-3.6-3.4-3.9L22.5,9.8z"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  fill: "#505050",
  d: "M27,10.9h2.6c0.3,0,0.6-0.3,0.6-0.6c0,0,0,0,0,0c0-0.3-0.3-0.6-0.6-0.6l0,0H27c-0.3,0-0.6,0.3-0.6,0.6l0,0 C26.5,10.6,26.7,10.9,27,10.9C27,10.9,27,10.9,27,10.9z"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  fill: "#505050",
  d: "M27,13.8h1.4c0.3,0,0.6-0.3,0.6-0.6c0,0,0,0,0,0c0.1-0.3-0.1-0.5-0.4-0.6c-0.1,0-0.2,0-0.2,0H27 c-0.3,0-0.6,0.3-0.6,0.6c0,0,0,0,0,0C26.5,13.5,26.7,13.8,27,13.8L27,13.8z"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  fill: "#505050",
  d: "M27,16.6h2.6c0.3,0,0.6-0.3,0.6-0.6c0-0.3-0.3-0.6-0.6-0.6H27c-0.3,0-0.6,0.3-0.6,0.6l0,0 C26.5,16.3,26.7,16.6,27,16.6z"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  fill: "#505050",
  d: "M27,19.5h1.4c0.3,0,0.6-0.3,0.6-0.6v0c0.1-0.3-0.1-0.5-0.4-0.6c-0.1,0-0.2,0-0.2,0H27 c-0.3,0-0.6,0.3-0.6,0.6v0C26.5,19.2,26.7,19.5,27,19.5L27,19.5z"
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  fill: "#505050",
  d: "M29.6,21.1H27c-0.3,0-0.6,0.3-0.6,0.6s0.3,0.6,0.6,0.6c0,0,0,0,0,0h2.6c0.3,0,0.6-0.3,0.6-0.6 C30.2,21.4,30,21.1,29.6,21.1z"
});

function SvgHot(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "45px",
    height: "45px",
    viewBox: "0 0 45 45",
    enableBackground: "new 0 0 45 45",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHot);
export default __webpack_public_path__ + "static/media/hot.9db80b18ac601755f22090f0bb2de42a.svg";
export { ForwardRef as ReactComponent };